import React from "react";

const ErrorHandling = ({ error }) => {
  if (!error) return null;
  // console.log("ERROR: ", error);
  return <p className="gkit-p-15 text-danger my-3">{error.message || error}</p>;
};

export default ErrorHandling;
